import { z } from 'zod';
import { IsoDateTimeSchema, TenantIdSchema, UuidSchema } from './common';

export const TenantSchema = z.object({
  id: TenantIdSchema,
  name: z.string(),
  displayName: z.string().nullable(),
  status: z.enum(['active', 'suspended', 'deleted']),
  branding: z.record(z.string(), z.unknown()).default({}),
  integrations: z.record(z.string(), z.unknown()).default({}),
  createdAt: IsoDateTimeSchema,
  updatedAt: IsoDateTimeSchema,
});
export type Tenant = z.infer<typeof TenantSchema>;

export const TenantUpdateSchema = z.object({
  name: z.string().min(1).max(200).optional(),
  displayName: z.string().max(200).nullable().optional(),
  branding: z.record(z.string(), z.unknown()).optional(),
  integrations: z.record(z.string(), z.unknown()).optional(),
});
export type TenantUpdateInput = z.infer<typeof TenantUpdateSchema>;

export const ApiKeySchema = z.object({
  id: UuidSchema,
  tenantId: TenantIdSchema,
  name: z.string(),
  keyMasked: z.string(),
  scopes: z.array(z.string()),
  active: z.boolean(),
  createdAt: IsoDateTimeSchema,
  lastUsedAt: IsoDateTimeSchema.nullable(),
  expiresAt: IsoDateTimeSchema.nullable(),
});
export type ApiKey = z.infer<typeof ApiKeySchema>;

export const ApiKeyCreateInputSchema = z.object({
  name: z.string().min(1).max(200),
  scopes: z.array(z.string()).default([]),
  expiresAt: IsoDateTimeSchema.nullable().optional(),
});
export type ApiKeyCreateInput = z.infer<typeof ApiKeyCreateInputSchema>;

/** Csak létrehozáskor — a `key` egyszer látható, utána már csak masked. */
export const ApiKeyCreatedSchema = ApiKeySchema.extend({
  key: z.string(),
});
export type ApiKeyCreated = z.infer<typeof ApiKeyCreatedSchema>;
